module.exports = __webpack_public_path__ + "brandon_blk_it-webfont.fd5f32cda75c652c5f88.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/brandon_blk_it-webfont.woff
// module id = 937
// module chunks = 7